import axios from '@/server/request'

const state = {
    leaderDetailData: {},
    relevantLeaderOptions: []
}

const mutations = {
    updateLeaderDetail(state, payload) {
        state.leaderDetailData = null
        state.leaderDetailData = payload
    },

    updateRelevantLeader(state, payload) {
        state.relevantLeaderOptions.splice(0)
        state.relevantLeaderOptions = payload
    }
}

const actions = {
    // 领导人详情
    async fetchLeaderDetail({ commit }, params) {
        try {
            const res = await axios.get({
                url: '/leader/detail',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateLeaderDetail', res.data.Data)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 领导人详情
    async fetchRelevantLeader({ commit }, params) {
        try {
            const res = await axios.get({
                url: '/leader/more',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateRelevantLeader', res.data.Data)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters: {},
    mutations,
    actions
}
